var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"expiration-time"},[_c('base-smart-countdown',{attrs:{"time-stamp":_vm.currentPurchasedExpirationTime,"hide-days":"","hide-hours":""},on:{"onTimeEnds":_vm.onExpirationTime}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }